import {EasingFunctions} from './utils';
import * as _ from 'lodash';


export class Animation{
  constructor(func, duration, App, ...args){
    this.name = func.name;
    this.func = func(App, ...args);
    this.duration = duration;
    this.startTime = Date.now();
  }
}


export class Animations{
  constructor() {
    this.animations = [];
  }

  execute() {
    let forSplice = [];
    for (let i = 0; i < this.animations.length; i ++)
    {
      let animation = this.animations[i];
      if ((Date.now() - animation.startTime) / animation.duration >= 1){
        animation.func(1);
        forSplice.push(i);
      }
      else if ((Date.now() - animation.startTime) / animation.duration >= 0){
        animation.func((Date.now() - animation.startTime) / animation.duration)
      }
    }

    this.animations.splice(...forSplice);
  }
}


export var zoomAnimation = (App, event) => {
  let toElement = event.toElement ? event.toElement: event.target;
  let clientX = event.clientX - $(toElement).offset().left;
  let coefficient = clientX < App.chart._width ? clientX / App.chart._width: 1;
  let distance = 1 / 3 * event.deltaY / Math.abs(event.deltaY) * (App.endTimestamp - App.startTimestamp);
  let oldStartTimestamp = App.startTimestamp;
  let oldEndTimestamp = App.endTimestamp;

  return (time) => {
    if (!distance) {
      return;
    }
    App.startTimestamp = oldStartTimestamp - EasingFunctions.easeInOutCubic(time) * coefficient * distance;
    App.endTimestamp = oldEndTimestamp + EasingFunctions.easeInOutCubic(time) * (1 - coefficient) * distance;
  }
};


export var yScaleAnimation = (App, newMax, newMin) => {
  let maxDistance = newMax - App.maxValue;
  let oldMaxValue = App.maxValue;
  let minDistance = newMin - App.minValue;
  let oldMinValue = App.minValue;

  return (time) => {
    App.maxValue = oldMaxValue + EasingFunctions.easeInOutCubic(time) * maxDistance;
    App.minValue = oldMinValue + EasingFunctions.easeInOutCubic(time) * minDistance;
  }
};


export var newPointAnimation = (App, point) => {
  let oldLastPoint = _.last(App.points);
  let timestampDistance = point.timestamp - oldLastPoint.timestamp;
  let valueDistance = point.value - oldLastPoint.value;
  point.value = oldLastPoint.value;
  point.timestamp = oldLastPoint.timestamp;
  App.points.push(point);

  return (time) => {
    point.timestamp = oldLastPoint.timestamp + timestampDistance * EasingFunctions.linear(time);
    point.value = oldLastPoint.value + valueDistance * EasingFunctions.linear(time);
    if (time == 1){
      point.timestamp = point.initialTimestamp;
      point.value = point.initialValue;
    }
  }
};

export var glowPointAnimation = (App) => {
  return (time) => {
    App.chart.lastPoint.alpha = -Math.abs(2*time - 1) + 1;
  }
};
